var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVertMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M24 40Q23 40 22.3 39.3Q21.6 38.6 21.6 37.6Q21.6 36.6 22.3 35.9Q23 35.2 24 35.2Q25 35.2 25.7 35.9Q26.4 36.6 26.4 37.6Q26.4 38.6 25.7 39.3Q25 40 24 40ZM24 26.4Q23 26.4 22.3 25.7Q21.6 25 21.6 24Q21.6 23 22.3 22.3Q23 21.6 24 21.6Q25 21.6 25.7 22.3Q26.4 23 26.4 24Q26.4 25 25.7 25.7Q25 26.4 24 26.4ZM24 12.8Q23 12.8 22.3 12.1Q21.6 11.4 21.6 10.4Q21.6 9.4 22.3 8.7Q23 8 24 8Q25 8 25.7 8.7Q26.4 9.4 26.4 10.4Q26.4 11.4 25.7 12.1Q25 12.8 24 12.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVertMenu);
export default __webpack_public_path__ + "static/media/vert-menu.dc7783373e1c4aaf08e8d7774b17764c.svg";
export { ForwardRef as ReactComponent };